import { useState } from 'react';

import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/TailwindComponents';

interface PrintModalProps {
  open: boolean;
  onClose: () => void;
  onPrint: (
    action: 'REDACTED' | 'UNREDACTED',
    includeHelpSheet: boolean,
  ) => Promise<void>;
}

export const DomesticIncidentReportPrintModal = ({
  open,
  onClose,
  onPrint,
}: PrintModalProps) => {
  const [includeHelpSheet, setIncludeHelpSheet] = useState<boolean>(false);
  const [printingAction, setPrintingAction] = useState<
    'REDACTED' | 'UNREDACTED' | null
  >(null);

  const handlePrint = async (action: 'REDACTED' | 'UNREDACTED') => {
    setPrintingAction(action);
    try {
      await onPrint(action, includeHelpSheet);
    } finally {
      setPrintingAction(null);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-[592px] [&>button.absolute]:text-red-500">
        <DialogHeader className="border-b pb-4">
          <DialogTitle>Print DIR Record</DialogTitle>
        </DialogHeader>

        <div className="space-y-6 relative">
          <p className="text-grey-100">
            Please select the type of print you would like to generate for this
            DIR record.
            <br />
            You can choose to print a <strong>Redacted</strong> or{' '}
            <strong>Unredacted</strong> version.
          </p>
          <p className="text-grey-100">
            <strong>Optionally</strong>, you may include the help sheet by
            selecting the checkbox below.
          </p>

          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={includeHelpSheet}
              onChange={(e) => setIncludeHelpSheet(e.target.checked)}
              className="h-4 w-4 rounded border-gray-300"
            />
            <span className="text-sm font-medium">Include Help Sheet</span>
          </label>

          <div className="flex justify-end gap-3 pt-4 border-t">
            <Button
              type="button"
              className="rounded-md bg-white"
              variant="outline"
              onClick={onClose}
              disabled={!!printingAction}
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant="default"
              className="rounded-md"
              onClick={() => handlePrint('REDACTED')}
              disabled={!!printingAction}
            >
              {printingAction === 'REDACTED' ? 'Printing...' : 'Redacted'}
            </Button>
            <Button
              type="button"
              variant="default"
              className="rounded-md"
              onClick={() => handlePrint('UNREDACTED')}
              disabled={!!printingAction}
            >
              {printingAction === 'UNREDACTED' ? 'Printing...' : 'Unredacted'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
